/**
 * 网络状态检测插件
 * @description 监听网络状态变化并提供用户反馈
 */
import { ElMessage, ElNotification } from 'element-plus'

// 网络状态通知实例引用
let offlineNotification: ReturnType<typeof ElNotification> | null = null

/**
 * 设置网络状态监听
 * @description 在应用初始化时调用，监听网络离线/在线事件
 */
export function setupNetworkStatus() {
  // 检测初始网络状态
  if (!navigator.onLine) {
    showOfflineWarning()
  }

  // 监听网络离线事件
  window.addEventListener('offline', () => {
    showOfflineWarning()
  })

  // 监听网络恢复事件
  window.addEventListener('online', () => {
    hideOfflineWarning()
    ElMessage.success({
      message: '网络已恢复',
      grouping: true,
    })
  })

  if (import.meta.env.DEV) {
    console.warn('✅ [网络状态] 网络状态监听已初始化')
  }
}

/**
 * 显示离线警告通知
 */
function showOfflineWarning() {
  // 避免重复显示
  if (offlineNotification)
    return

  offlineNotification = ElNotification({
    title: '网络已断开',
    message: '部分功能可能不可用，请检查网络连接',
    type: 'warning',
    duration: 0, // 不自动关闭
    showClose: true,
    onClose: () => {
      offlineNotification = null
    },
  })
}

/**
 * 隐藏离线警告通知
 */
function hideOfflineWarning() {
  if (offlineNotification) {
    offlineNotification.close()
    offlineNotification = null
  }
}

/**
 * 获取当前网络状态
 * @returns 是否在线
 */
export function isOnline(): boolean {
  return navigator.onLine
}

export default setupNetworkStatus
